module.exports = __webpack_public_path__ + "img/gateway-usdterc20-logo.f4851f8c.svg";